/* eslint-disable import/prefer-default-export */
import path from 'path-browserify';

import { TenantAppSearchQueryType } from '@router/routes/types';

export const ENTRY_POINTS = Object.freeze({
  URL: Object.freeze({
    CALIFORNIA_NOTICE: () => 'https://www.zipteam.com/ccpa',
    PRIVACY_POLICY: () => 'https://www.zipteam.com/privacy',
    HELP_CENTER: () => 'https://docs.zipteam.com',
    TERMS_OF_SERVICE: () => 'https://www.zipteam.com/terms',
    LANDING: () => 'https://zipteam.com',
    UNAUTHORIZED: () => `${path.join(process.env.BASE_URL, 'auth')}`,
    USER: () => `${path.join(process.env.BASE_URL, 'dashboard')}`,
    TENANT: () => `${path.join(process.env.BASE_URL, 'workspace')}`,
  }),
  PATH: Object.freeze({
    EMAIL_VERIFICATION: ({
      context = 'signup',
    }: {
      context?: 'signup' | 'login' | 'password-reset',
    } = {}) => ({
      name: 'email-verification',
      params: { context },
    }),
    AUTH_CODE_ERROR: ({
      context,
      expired,
    }: {
      context?: 'signup' | 'password-reset' | 'tenant-invitation' | 'unknown',
      expired?: boolean,
    } = {
      context: 'unknown',
      expired: false,
    }) => ({
      name: 'auth-code-error',
      params: { context },
      query: { expired },
    }),
    SIGNUP_TOP: () => ({
      name: 'email-verification',
      params: {
        context: 'signup',
      },
    }),
    LOGIN_TOP: () => ({
      name: 'email-verification',
      params: {
        context: 'login',
      },
    }),
    PASSWORD_RESET_TOP: () => ({
      name: 'email-verification',
      params: {
        context: 'password-reset',
      },
    }),
    SIGNUP: ({ query } = { query: {} }) => ({ name: 'signup', query }),
    LOGIN: ({ query } = { query: {} }) => ({ name: 'login', query }),
    PASSWORD_RESET: ({
      query,
    } = {
      query: {},
    }) => ({ name: 'password-reset', query }),
    UNAUTHORIZED: () => ({
      name: 'email-verification',
      params: { context: 'login' },
    }),
    USER_HOME: () => ({ name: 'user-home' }),
    TENANT_HOME: () => ({ name: 'tenant-home' }),
    TENANT_USER: ({
      params,
      query,
    }: {
      params: {
        tenantUserId?: number;
      },
      query: {
        index?: number;
      },
    } = {
      params: {},
      query: {},
    }) => ({ name: 'tenant-user', params, query }),
    TENANT_USERS: () => ({ name: 'tenant-users' }),
    TEAMUP_HOME: (tenantUserId = null) => ({
      name: 'teamup-home',
      ...(!tenantUserId ? {
        params: {
          tenantUserId,
        },
      } : {}),
    }),
    ADMIN_SURVEY_HOME: () => ({ name: 'admin-survey-home' }),
    ASSESSMENT_IMPORT_HISTORY: () => ({ name: 'assessment-import-history' }),
    ASSESSMENT_SKILL_SCORES: ({
      assessmentId,
    }: {
      assessmentId?: number | null;
    } = {
      assessmentId: null,
    }) => ({
      name: 'assessment-skill-scores',
      params: {
        assessmentId,
      },
    }),
    REVIEW_MANAGE: ({
      reviewCode,
    }: {
      reviewCode: string;
    } = {
      reviewCode: '',
    }) => ({
      name: 'review-manage',
      params: {
        reviewCode,
      },
    }),
    REVIEW_REVIEWEE: ({
      reviewCode,
      revieweeId,
    }: {
      reviewCode: string;
      revieweeId: number | null;
    } = {
      reviewCode: '',
      revieweeId: null,
    }) => ({
      name: 'reviewee',
      params: {
        reviewCode,
        revieweeId,
      },
    }),
    SKILL_TREES: () => ({ name: 'self-reviews' }),
    SKILL_TREE_MANAGE: ({
      skillTreeCode,
    }: {
      skillTreeCode?: string | null;
    } = {
      skillTreeCode: null,
    }) => ({
      name: 'skill-tree-manage',
      params: {
        skillTreeCode,
      },
    }),
    SKILLS_HUB_HOME: ({
      query,
    } = {
      query: {
        index: 0,
      },
    }) => ({ name: 'skills-hub-home', query }),
    TEAMS_HOME: () => ({ name: 'teams-home' }),
    TEAM_HOME: ({
      teamCode,
    }: {
      teamCode?: string | null;
    } = {
      teamCode: null,
    }) => ({
      name: 'team',
      params: {
        teamCode,
      },
    }),
    TEAM_SEARCH_TENANT_USERS: ({
      teamCode,
    }: {
      teamCode?: string | null;
    } = {
      teamCode: null,
    }) => ({
      name: 'team-search-tenant-users',
      params: {
        teamCode,
      },
    }),
    TEAM_FREE_SEARCH_TENANT_USERS: ({
      teamCode,
    }: {
      teamCode?: string | null;
    } = {
      teamCode: null,
    }) => ({
      name: 'team-free-search-tenant-users',
      params: {
        teamCode,
      },
    }),
    TENANT_APP_SEARCH: ({
      query,
    }: {
      query?: TenantAppSearchQueryType;
    } = {}) => ({ name: 'tenant-app-search', query }),
    TENANT_APP_SETTINGS: () => ({ name: 'tenant-app-settings' }),
    USER_APP_SETTINGS: () => ({ name: 'user-app-settings' }),
    TENANT_USER_SKILL_TREE: ({
      skillTreeCode,
    }: {
      skillTreeCode?: string | null;
    } = {
      skillTreeCode: null,
    }) => ({
      name: 'tenant-user-skill-tree',
      params: {
        skillTreeCode,
      },
    }),
  }),
});
